import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { weatherService } from '../../../../application/WeatherService';
import { WeatherForecast } from '../../../../domain/weather/WeatherForecast';
import { useErrorMiddlewareOld } from '../../../../hooks/useErrorMiddlewareOld';

type UseRetrieveWeatherForecastResponse = ServiceResponse<Function, WeatherForecast[]>;

export const useRetrieveWeatherForecast = (): UseRetrieveWeatherForecastResponse => {
  const { sessionExpiredLogout } = useErrorMiddlewareOld();

  const {
    data,
    isInitialLoading: isLoading,
    refetch,
    isError,
    isSuccess,
  } = useQuery(
    [`driver_weather_forecast`],
    (): Promise<WeatherForecast[]> => {
      return weatherService.retrieveForecast();
    },
    {
      retry: false,
      enabled: true,
      staleTime: 3_600_000, // 1 hour
      onError: (err: any) => {
        console.info(`Weather Forecast Error: `, err?.response);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }
      },
    }
  );

  return {
    error: isError,
    isLoading,
    success: isSuccess,
    run: refetch,
    data,
  };
};
